export default {"src":"/_next/static/media/racing-white.b97ffeab.svg","height":567,"width":86};